import { h, Host } from "@stencil/core";
export class SidebarFooter {
    render() {
        return (h(Host, { key: '212b4a72ae7ccb0109fcd0f4da17eb7dc4b0a939', class: "ux-sidebar-footer" }, h("slot", { key: 'f34d26457da7ea3dc34e5045a0a355b524a61346' })));
    }
    static get is() { return "ux-sidebar-footer"; }
    static get originalStyleUrls() {
        return {
            "$": ["sidebar-footer.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["sidebar-footer.css"]
        };
    }
}
//# sourceMappingURL=sidebar-footer.js.map
